import { palette } from '@livable/saas-react-components';
const MuiMenuItem = {
  styleOverrides: {
    root: {
      padding: '12px 20px',
      fontSize: '18px',
      lineHeight: '24px',
      transition: "background-color ".concat(palette.transitions.short),
      '&:hover': {
        backgroundColor: palette.shades[300],
        '.MuiCheckbox-root': {
          color: palette.shades[800]
        }
      },
      '.MuiCheckbox-root': {
        padding: '0'
      },
      '&.Mui-disabled': {
        display: 'none'
      },
      '&.Mui-selected': {
        backgroundColor: palette.primary.main,
        color: palette.shades[100],
        '&:hover': {
          backgroundColor: palette.primary.dark
        }
      },
      '&.Mui-focusVisible': {
        backgroundColor: palette.shades[300],
        '&:hover': {
          backgroundColor: palette.shades[300]
        },
        '&.Mui-selected': {
          backgroundColor: palette.primary.dark
        }
      }
    }
  },
  variants: [{
    props: {
      variant: 'multiple'
    },
    style: {
      '&.Mui-selected': {
        backgroundColor: palette.shades[200],
        color: palette.shades[800],
        '&:hover': {
          backgroundColor: palette.shades[300],
          '.MuiCheckbox-root': {
            color: palette.primary.main
          }
        }
      },
      '.MuiCheckbox-root': {
        marginRight: '8px'
      },
      '&.Mui-focusVisible': {
        '.MuiCheckbox-root': {
          color: palette.shades[800]
        },
        '&.Mui-selected': {
          backgroundColor: palette.shades[300],
          '.MuiCheckbox-root': {
            color: palette.primary.main
          }
        }
      }
    }
  }]
};
export default MuiMenuItem;